// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2019-01-25T10:29:09Z                      #

// ##############################################################

import ErrorApi from "./../../../utils/ErrorApi";
import Fetch from "./../../../utils/Fetch";
import ParamsFetch from "./../../../utils/ParamsFetch";
import JsonFetch from "./../../../utils/JsonFetch";
import generateUrl from './../../../utils/generateUrl';

import * as UpdateMethods from "./UpdateMethods";

/**
 * Rozhraní pro přístup ke spisovým službám. Generated from cz.marbes.api.dokument.spisovasluzba.SpisovaSluzbaService.
 */
export default class SpisovaSluzbaApi {
    /**
     * Načtení id dokumentů, které mají nějaká nedoručená vypravení - myšleno vypravení bez kladné/záporné informace o doručení.
     *
     * @return seznam id dokumentů
     */
    static getDokumentyIdsHromadnyUpdateVypraveni() : Promise<number[]> {
        const uri = serverContextPath + `/api/spisovasluzba/vypraveni/dokumentyIdsNeznamyStavVypraveni`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * 
     *
     * @return položky spisového plánu
     */
    static getSpisovyPlan() : Promise<VecnaSkupina[]> {
        const uri = serverContextPath + `/api/spisovasluzba/spisovyplan`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * 
     *
     * @param kodyZpusobuVypraveni kódy způsobů vypravení
     * @return způsoby vypravení odpovídající předaným kódům
     */
    static findZpusobyVypraveni(kodyZpusobuVypraveni : string[]) : Promise<ZpusobVypraveni[]> {
        const uri = serverContextPath + `/api/spisovasluzba/zpusoby/vypraveni`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, kodyZpusobuVypraveni, headers));
    }

    /**
     * Dodatečně předá vypravení do spisové služby - předá výpravně. Akce slouží pouze pro existující vypravení, které zatím nebylo předáno do SPS - je ve stavu nevypraveno.
     *
     */
    static dodatecnePredatKVypraveni() {
        const uri = serverContextPath + `/api/spisovasluzba/dokument/{dokumentId}/vypraveni/{vypraveniId}/dodatecnePredatKVypraveni`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.put(uri, params, 0, headers));
    }

    /**
     * Smaže vyvěšení s daným ID.
     *
     * @param id 
     */
    static deleteVyveseni(id : number) {
        const uri = serverContextPath + `/api/spisovasluzba/vyveseni/${id}/delete`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.delete(uri, params));
    }

    /**
     * Zapíše doručenku vypravení, s propadem až do spisové služby.
     *
     * @param id 
     * @param stavVypraveni hodnota jak vypravení doručeno/nedoručeno/...
     * @param datumDoruceni datum, který bude zaevidována jako datum doručení/nedoručení adresátu
     * @return aktualizované vypravení
     */
    static zapsatDorucenku(id : number, stavVypraveni : StavVypraveni, datumDoruceni : string) : Promise<Vypraveni> {
        const uri = serverContextPath + `/api/spisovasluzba/vypraveni/${id}/doruceni`;
        const headers = undefined;
        const params = { stavVypraveni, datumDoruceni };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, 0, headers));
    }

    /**
     * Fultextové vyhledání spisů.
     *
     * @param fulltext vyhledávací kritérium
     * @return 
     */
    static findSpisy(fulltext : string) : Promise<Spis[]> {
        const uri = serverContextPath + `/api/spisovasluzba/spisy`;
        const headers = undefined;
        const params = { fulltext };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * Vrací výchozí hodnoty, pro předaný kód typu dokumentu.
     *
     * @param kod kód typu dokumentu, pro který výchozí hodnoty požadujeme
     * @return nalezené výchozí hodnoty, nebo vyjímka
     */
    static getVychoziHodnoty(kod : string) : Promise<VychoziHodnoty> {
        const uri = serverContextPath + `/api/spisovasluzba/typdokument/${kod}/vychozihodnoty`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * 
     *
     * @param typKontakt typ kontaktu
     * @return způsoby vypravení pro typ kontaktu
     */
    static findZpusobyVypraveniByTypKontakt(typKontakt : TypKontakt) : Promise<ZpusobVypraveni[]> {
        const uri = serverContextPath + `/api/spisovasluzba/zpusoby/vypraveni/typkontakt/${typKontakt}`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * Uloží předaný spis. Spis musí mít {@link Spis#getId() == null}
     *
     * @param inputSpis 
     * @return uložený spis
     */
    static createSpisZeSps(inputSpis : Spis) : Promise<Spis> {
        const uri = serverContextPath + `/api/spisovasluzba/spis/create`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.put(uri, params, UpdateMethods.updateSpis_CA4FE8(inputSpis), headers));
    }

    /**
     * Založí spis nad doručeným dokumentem.
     *
     * @param id ID doručeného dokumentu
     * @param inputSpis 
     * @return uložený a odeslaný spis do SPS
     */
    static createSpisNadDokumentem(id : number, inputSpis : Spis) : Promise<Spis> {
        const uri = serverContextPath + `/api/spisovasluzba/dokument/${id}/spis/create`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.put(uri, params, UpdateMethods.updateSpis_CA4FE8(inputSpis), headers));
    }

    /**
     * Vrací poslední vyvěšení dokumentu
     *
     * @param dokumentId 
     * @return {@link Vyveseni}, nebo {@code null}
     */
    static findVyveseniDokumentu(dokumentId : number) : Promise<Vyveseni> {
        const uri = serverContextPath + `/api/spisovasluzba/dokument/${dokumentId}/vyveseni`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * 
     *
     * @return podporované funkce
     */
    static getSupportedFunction() : Promise<SupportedFunction> {
        const uri = serverContextPath + `/api/spisovasluzba/supportedfunction`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * Najde vypravení s předanými ID.
     *
     * @param ids množina ID vypravení
     * @return nalezená vypravení
     */
    static findVypraveniByIds(ids : number[]) : Promise<Vypraveni[]> {
        const uri = serverContextPath + `/api/spisovasluzba/vypraveni/batchRequest`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, ids, headers));
    }

    /**
     * Nastaví spisu nového zpracovatele.
     *
     * @param id 
     * @param zpracovatel nový zpracovatel spisu
     */
    static predatSpis(id : number, zpracovatel : Pracovnik) {
        const uri = serverContextPath + `/api/spisovasluzba/spis/${id}/predat`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.put(uri, params, UpdateMethods.updatePracovnik_1DDB32(zpracovatel), headers));
    }

    /**
     * Vrací pravidla vypravení, dle předaných kódů pravidel
     *
     * @param kodyPravidelVypraveni kódy pravidel vypravení
     * @return způsoby vypravení dle předaných kódů pravidel
     */
    static findZpusobyVypraveniByPravidlo(kodyPravidelVypraveni : string[]) : Promise<VypraveniPravidloZpusob[]> {
        const uri = serverContextPath + `/api/spisovasluzba/zpusoby/vypraveni/pravidla`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, kodyPravidelVypraveni, headers));
    }

    /**
     * Vrací seznam kategorií úřední desky, načtenou ze spisové služby.
     *
     * @return kolekce kategorií
     */
    static getKategorieUredniDesky() : Promise<KategorieUredniDesky[]> {
        const uri = serverContextPath + `/api/spisovasluzba/kategorieurednidesky`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * Znovu otevře spis.
     *
     * @param id 
     * @param duvod důvod znovu otevření spisu
     */
    static otevritSpis(id : number, duvod : string) {
        const uri = serverContextPath + `/api/spisovasluzba/spis/${id}/otevrit`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.put(uri, params, duvod, headers));
    }

    /**
     * Aktualizuje obsah spisu ze spisové služby do struktur SPS.
     *
     * @param id ID spisu
     * @return aktuální obsah spisu
     */
    static obnovitObsahSpisu(id : number) : Promise<ObsahSpisu> {
        const uri = serverContextPath + `/api/spisovasluzba/spis/${id}/obsah/obnovit`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * Provede aktualizaci všech vypravení týkajících se dokumentů, které jsou uvedeny v parametru.
     *
     * @param updateParams seznam dokumentů pro aktualizaci s definicí logického vlastníka dokumentu
     * @param generateOznameni pokud je true, generuje se pro nové doručenky oznámení o přijatých doručenkách
     * @return seznam JEN aktualizovaných vypravení @deprecated - nechceme a nebudeme vracet!!!
     */
    static updateVypraveniDokumentu(updateParams : UpdateVypraveniDokumentuParam[], generateOznameni : boolean) : Promise<Vypraveni[]> {
        const uri = serverContextPath + `/api/spisovasluzba/vypraveni/updateVypraveniDokumentu`;
        const headers = undefined;
        const params = { generateOznameni };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, updateParams, headers));
    }

    /**
     * 
     *
     * @return nakonfigurovaná pravidla způsobu vypravení
     */
    static findPravidlaVypraveni() : Promise<VypraveniPravidlo[]> {
        const uri = serverContextPath + `/api/spisovasluzba/pravidla/vypraveni`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * Vytvoří vyvěšení na úřední desku, které lze případně dle parametru také předat výpravně.
     *
     * @param id 
     * @param inputVyveseni 
     * @param predatKVypraveni příznak, zda se má vypravení po jeho založení do spisové služby také předat vyýpravně
     */
    static vyvesitNaUD(id : number, inputVyveseni : Vyveseni, predatKVypraveni : boolean) {
        const uri = serverContextPath + `/api/spisovasluzba/dokument/${id}/vyvesitNaUD`;
        const headers = undefined;
        const params = { predatKVypraveni };
         
        return ErrorApi.responseResolver(JsonFetch.put(uri, params, UpdateMethods.updateVyveseni_9DCD37(inputVyveseni), headers));
    }

    /**
     * Vrací všechny typy dokumentů ze spisové služby seřazené dle {@link SpsTypDokument#getNazev()}.
     *
     * @return typy dokumentů
     */
    static findTypyDokumentu() : Promise<SpsTypDokument[]> {
        const uri = serverContextPath + `/api/spisovasluzba/typydokumentu`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, 0, headers));
    }

    /**
     * Propojí předaný dokument se spisem.
     *
     * @param id 
     * @param dokumentId ID dokument, který bude do předaného spisu zařazen
     */
    static zaradDokumentDoSpisu(id : number, dokumentId : number) {
        const uri = serverContextPath + `/api/spisovasluzba/spis/${id}/dokument/${dokumentId}`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * Vrátí spis dle předaného ID.
     *
     * @param id 
     * @return {@link Spis}
     */
    static getSpisById(id : number) : Promise<Spis> {
        const uri = serverContextPath + `/api/spisovasluzba/spis/${id}`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * Vrátí profil spisu + dokumenty ve spisu obsažené. Dokumenty jsou řazeny sestupně!
     *
     * @param id 
     * @return {@link Spis}
     */
    static getObsahSpisu(id : number) : Promise<ObsahSpisu> {
        const uri = serverContextPath + `/api/spisovasluzba/spis/${id}/obsah`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * Uzavře spis.
     *
     * @param id 
     * @param duvod důvod uzavření
     */
    static uzavritSpis(id : number, duvod : string) {
        const uri = serverContextPath + `/api/spisovasluzba/spis/${id}/uzavrit`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.put(uri, params, duvod, headers));
    }

    /**
     * Vytvoří vypravení, které lze odeslat do spisové služby (případně dle parametru také předat výpravně).
     *
     * @param id 
     * @param inputVypraveni 
     * @param predatKVypraveni příznak, zda se má vypravení po jeho založení do spisové služby také předat vyýpravně
     * @return uložené vypravení
     */
    static vypravit(id : number, inputVypraveni : Vypraveni, predatKVypraveni : boolean) : Promise<Vypraveni> {
        const uri = serverContextPath + `/api/spisovasluzba/dokument/${id}/vypravit`;
        const headers = undefined;
        const params = { predatKVypraveni };
         
        return ErrorApi.responseResolver(JsonFetch.put(uri, params, UpdateMethods.updateVypraveni_B72A36(inputVypraveni), headers));
    }

    /**
     * Aktualizuje existující spis.
     *
     * @param id 
     * @param inputObsahSpisu 
     * @return aktualizovaný spis
     */
    static updateObsahSpisu(id : number, inputObsahSpisu : ObsahSpisu) : Promise<ObsahSpisu> {
        const uri = serverContextPath + `/api/spisovasluzba/spis/${id}/obsah/update`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.put(uri, params, UpdateMethods.updateObsahSpisu_15977C(inputObsahSpisu), headers));
    }

    /**
     * Najde vypravení s předanými identifikátory vypravení.
     *
     * @param kodyNaObalku seznam čárových kódů (nascanovaných čtečkou čárových kódů z obálek)
     * @return nalezená vypravení
     */
    static findVypraveniByKodNaObalku(kodyNaObalku : string[]) : Promise<Vypraveni[]> {
        const uri = serverContextPath + `/api/spisovasluzba/vypraveni/filter`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, kodyNaObalku, headers));
    }

}